import { useState, useEffect } from 'react';
import { Table, TableBody, TableHead, TableRow, Checkbox, Grid, makeStyles } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { getAllTransactions } from '../../../store/constructs/transactions/selectors';
import UpdateCancel from '../../atoms/buttons/UpdateCancel';
import { toggleRightDrawer, handleSnackBar } from '../../../store/global/actions';
import { removeTemplateTransaction } from '../../../store/constructs/transactions/actions';
import { StyledTableCell, StyledTableRow } from '../../atoms/table/tableStyles';
import { getTemplateClusterlets } from '../../../store/constructs/templated_clusterlet/selectors';
import { getClusterletConnections } from '../../../store/constructs/clusterlet_connections/selectors';
import { setHandler, findHandlers } from '../../../services/blueprint.js';
import { updateFullHandlers } from "../../../store/constructs/handlers/actions";
import { getLuaEditorData } from "../../../store/constructs/handlers/selectors";
import { onDeleteLuaFiles } from '../../../store/constructs/handlers/actions';
import EventsAlert from '../alerts/EventsAlert'
import { nodeKeysLabel } from '../../../config/common';
import { invokePostService, invokeGetService, setReRender } from "../../../store/global/actions";
import { useParams } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';


const useStyles = makeStyles((theme) => ({
    tableCellPadding: {
        paddingLeft: "16px"
    }
}));


export default function EditTransactionNodes({ onCompletion, onClose, element }) {
    const dispatch = useDispatch();
    const classes = useStyles();

    const transactions = useSelector(getAllTransactions);
    const params = useParams();
    const history = useHistory();
    const currentUrl = window.location.href;


    const [clusterlets, setClusterlets] = useState([])
    const delegates = clusterlets.filter(c => c.type == 1);
    const digitalTwins = clusterlets.filter(c => c.type == 2);
    const analytics = clusterlets.filter(c => c.type == 3);
    // const transaction = transactions.find(t => t.id == element.id);
    const templateClusterlets = useSelector(getTemplateClusterlets);
    const connections = useSelector(getClusterletConnections);
    const handlersInState = useSelector(getLuaEditorData);
    // const [nodes, setNodes] = useState([...transaction.clusterlets]);
    const [nodes, setNodes] = useState([]);
    const [nodesToEnable, setNodesToEnable] = useState([])
    const [evnetsAlert, setEventAlert] = useState(false);
    const [associatedEvents, setAssociatedEvents] = useState([]);
    const [selectedNode, setSelectedNode] = useState({})
    // const transactionEvents = useSelector(getTransactionAssociatedEvents(transaction))
    const [transaction, setTransaction] = useState([])
    const [transactionEvents, setTransactionEvents] = useState([])
    const [slug, blueprintID, tag, transactionId] = currentUrl.split('/').slice(4);
    const [isUpdating, setIsUpdating] = useState(false)
    const [loading, setLoading] = useState(true);
    const [selectedTransactionId, setSelectedTransactionId] = useState(params.transaction == element.id ? params.transaction : element.id)
    const [missingClusterlets, setMissingClusterlets] = useState([])

    // const transactionNodes = [...delegates, ...digitalTwins, ...analytics, ...templateClusterlets]; ;
    const filterTransactionNodes = (delegates, digitalTwins, analytics) => {
        let nodes = []

        delegates.forEach(item => {
            nodes.push({ ...item, clusterletType: "Delegate" })
        })

        digitalTwins.forEach(item => {
            nodes.push({ ...item, clusterletType: "Digital Twin" })
        })

        analytics.forEach(item => {
            let type = item?.attributes?.type ? nodeKeysLabel[item?.attributes?.type] : process.env.REACT_APP_ANALYTICS
            nodes.push({ ...item, clusterletType: type })
        })

        nodes = nodes.sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            } else if (a.name > b.name) {
                return 1;
            } else {
                return 0;
            }
        })
        return nodes;
    }

    useEffect(() => {

        if (params.transaction == element.id) {
            console.log("---if----")
            dispatch(invokeGetService('getTransactionAssociates', [params.transaction]))
                .then((response) => {
                    if (response.data.transaction !== undefined) {
                        setTransaction(response?.data?.transaction)
                        setTransactionEvents(response?.data?.events);
                        setNodes(response?.data?.clusterlets);
                        setClusterlets(response?.data?.allClusterlets)
                        setLoading(false)
                    }
                    else if (response?.status == false && response?.code == 255 && response.transactionNotFound == true) {

                        history.push(`/blueprint/${slug}/${blueprintID}/system-model`);

                    }
                })
        } else{
            console.log("-----else------")
                
            // dispatch(invokeGetService('getTransactionAssociates', [params.transaction]))
            dispatch(invokeGetService('getTransactionAssociates', [element.id]))
                .then((parentTransactionResp) => {
                    let parentNodes = (parentTransactionResp?.data?.transaction != undefined && parentTransactionResp?.data?.transaction?.clusterlets) ? parentTransactionResp?.data?.transaction?.clusterlets.map(cl => cl.id) : []

                    dispatch(invokeGetService('getTransactionAssociates', [element.id]))
                        .then((response) => {
                            if (response.data.transaction !== undefined) {
                                let childNodes = response?.data?.transaction?.clusterlets ? response?.data?.transaction?.clusterlets.map(cl => cl.id) : []
                                setMissingClusterlets(findMissingElements(parentNodes, childNodes))
                                setTransaction(response?.data?.transaction)
                                setTransactionEvents(response?.data?.events);
                                setNodes(response?.data?.clusterlets);
                                setClusterlets(response?.data?.allClusterlets)
                                setLoading(false)
                            }
                            else if (response?.status == false && response?.code == 255 && response.transactionNotFound == true) {

                                history.push(`/blueprint/${slug}/${blueprintID}/system-model`);

                            }
                        })
                })


        }

    }, [])

    function findMissingElements(parent, child) {
        const missingElements = child.filter(element => !parent.includes(element));
        return missingElements;
    }


    const setNodeData = async (node, checked) => {
        checked ? setNodes([...nodes, node]) : setNodes(nodes.filter(n => n._id !== node._id));
    }

    const nodeEvents = (node) => {
        const nodeAssociatedEvents = transactionEvents.filter(event => (event.src == node?._id || event.dst == node?._id))
        return nodeAssociatedEvents;
    }

    const onSelect = async (node, checked) => {
        setSelectedNode(node)
        const evnetsForNode = nodeEvents(node);
        if (!checked && evnetsForNode.length > 0) {
            setAssociatedEvents(evnetsForNode)
            setEventAlert(true);
        }
        else if (checked || evnetsForNode.length == 0) {
            const nodesInState = nodes;
            const updatedNodes = checked ? [...nodes, node] : nodesInState.filter(nodeInStore => nodeInStore.id !== node._id)
            setNodesToEnable(updatedNodes)
            await setNodeData(node, checked);
        }
    }

    const onUpdate = async () => {
        setIsUpdating(true)

        if (missingClusterlets.length > 0) {
            dispatch(handleSnackBar({ open: true, message: 'Parent transaction does not cotain the nodes', severity: 'error' }));
            setIsUpdating(false)
            return false;
        }
        if (nodes.length == 0) {
            dispatch(handleSnackBar({ open: true, message: 'Select atleast one node', severity: 'error' }));
            setIsUpdating(false)
            return false;
        }

        if (nodes.length == 1) {
            dispatch(handleSnackBar({ open: true, message: 'Minimum two nodes must be selected to have a transaction', severity: 'error' }));
            setIsUpdating(false)
            return;
        }

        let handlersToAdd = [];
        let handlersToDelete = [];

        // Handlers handling when there is template transaction
        if (transaction?.templateTransactions !== undefined && transaction?.templateTransactions !== null && transaction?.templateTransactions.length > 0) {

            const selectedTemplateClusterlets = nodes.filter(node => node.category === 'templateClusterlet').map(item => item.id);
            const filteredTemplateTransactions = transaction.templateTransactions.filter(item => selectedTemplateClusterlets.includes(item.templateId));
            const clusterletBeforeEdit = transaction.clusterlets.filter(clusterlet => clusterlet.category === 'userdefined').map(item => item.id);
            const clusterletAfterEdit = nodes.filter(node => !selectedTemplateClusterlets.includes(node.id)).map(item => item.id);
            const clusterletAdded = clusterletAfterEdit.filter(node => !clusterletBeforeEdit.includes(node));
            const clusterletDeleted = clusterletBeforeEdit.filter(node => !clusterletAfterEdit.includes(node));
            const deletedTemplateTransactions = transaction.templateTransactions.filter(item => !selectedTemplateClusterlets.includes(item.templateId));

            //For removing template transactions when template clusterlet remove
            if (deletedTemplateTransactions.length > 0) {
                const removedTemplateClusterlet = [...new Set(deletedTemplateTransactions.map(item => item.templateId))];
                dispatch(removeTemplateTransaction(removedTemplateClusterlet, transaction.id));
            }


            //For adding handlers for each newly adding clusterlet
            if (filteredTemplateTransactions.length > 0 && clusterletAdded.length > 0) {
                let filteredTemplateTransactionsDetails = [];
                filteredTemplateTransactions.forEach(item => {
                    const template = templateClusterlets.find(template => template.id === item.templateId);
                    if (template !== undefined) {
                        const obj = template.metajson.callflowdefs[item.name]
                        obj.templateId = item.templateId;
                        if (obj !== undefined) filteredTemplateTransactionsDetails.push(obj);
                    }
                });

                filteredTemplateTransactionsDetails.forEach(ele => {
                    const selectedTemplate = templateClusterlets.find(template => template.id === ele.templateId);

                    const handlers = setHandler(ele, selectedTemplate, clusterletAdded);
                    if (handlers.length > 0) handlersToAdd = [...handlers];
                });
                if (handlersToAdd.length > 0) dispatch(updateFullHandlers(handlersToAdd));
            }

            // For removing the corresponding handlers when a template clusterlet removed
            if (deletedTemplateTransactions.length > 0) {
                let totalAssociatedHandlers = [];
                deletedTemplateTransactions.forEach(item => {
                    const templateClusterlet = templateClusterlets.find(template => template.id === item.templateId);
                    const associatedHandlers = findHandlers(item, templateClusterlet, handlersInState);
                    totalAssociatedHandlers = [...totalAssociatedHandlers, ...associatedHandlers];
                });
                handlersToDelete = [...totalAssociatedHandlers];
            }

            //For removing the corresponding handlers when userdefined clusterlet removing
            if (filteredTemplateTransactions.length > 0 && clusterletDeleted.length > 0) {
                let totalAssociatedHandlers = [];
                filteredTemplateTransactions.forEach(item => {
                    const templateClusterlet = templateClusterlets.find(template => template.id === item.templateId);
                    const associatedHandlers = findHandlers(item, templateClusterlet, handlersInState);
                    totalAssociatedHandlers = [...totalAssociatedHandlers, ...associatedHandlers];
                });
                const filterdHandlers = totalAssociatedHandlers.filter(item => clusterletDeleted.includes(item.clusterlet));
                filterdHandlers.forEach(handler => {
                    const index = handlersToDelete.findIndex(ele => ele.id === handler.id);
                    if (index === -1) {
                        handlersToDelete.push(handler);
                    }
                });
            }
            if (handlersToDelete.length > 0) dispatch(onDeleteLuaFiles(handlersToDelete, true));

        }


        const editTransaction = {
            ...transaction,
            clusterlets: nodes.map((node, key) => ({ id: node._id, order: key, category: node.category !== undefined ? node.category : 'userdefined' }))
        }


        // dispatch(onTransctionCreation(editTransaction, undefined, undefined, false, handlersToAdd, handlersToDelete));
        dispatch(invokePostService('updateTransactionNodes', { nodes: editTransaction.clusterlets }, [transaction._id]))
            .then((response) => {
                if (response.data) {
                    dispatch(setReRender())
                    dispatch(handleSnackBar({ open: true, message: `Transaction updated`, severity: "success" }));
                }
                else if (response.code == 254) {
                    dispatch(toggleRightDrawer());
                }
                else if (response?.status == false && response?.code == 255 && response.transactionNotFound == true) {

                    history.push(`/blueprint/${slug}/${blueprintID}/system-model`);

                }
                setIsUpdating(false)

            })

        // dispatch(reRenderInfoBuilder());
        if (process.env.REACT_APP_AUTO_CLOSE == 'true') {
            dispatch(toggleRightDrawer());
        }
    }

    const onCancel = () => {
        dispatch(toggleRightDrawer());
    }

    const isChecked = (id) => {
        return nodes.find(n => n._id == id) !== undefined ? true : false;
    }

    const isDisbaled = (nodeId) => {
        return false;
        let status = nodesToEnable.find(singleNnode => singleNnode._id === nodeId)

        if (nodes.length === 0 || nodesToEnable.length === 0) {
            return false;
        }

        return (status !== undefined) ? false : true;

    }

    const onConfirmUncheck = () => {
        setNodes(nodes.filter(n => n._id !== selectedNode._id));
        setEventAlert(false);
    }

    return (
        <Grid direction={"row"} spacing={3} xs={12}>

            <Grid>
                <Table >
                    <TableHead>
                        <TableRow>
                            <StyledTableCell component="th" align={'left'} ></StyledTableCell>
                            <StyledTableCell component="th" align={'left'} >Name</StyledTableCell>
                            <StyledTableCell component="th" align={'left'} >Clusterlet Type</StyledTableCell>
                            <StyledTableCell component="th" align={'left'} >Description</StyledTableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {loading ?
                            (<StyledTableRow>
                                <StyledTableCell align={'center'} colSpan={6} component="td" style={{ padding: 15 }}>
                                    Loading... <CircularProgress size={15} style={{ color: '#000' }} />
                                </StyledTableCell>
                            </StyledTableRow>)
                            : (
                                <>
                                    {
                                        filterTransactionNodes(delegates, digitalTwins, analytics).map(node => (
                                            <StyledTableRow>
                                                <StyledTableCell component="td" className={classes.tableCellPadding}  ><Checkbox checked={isChecked(node._id)} color='primary' onChange={e => onSelect(node, e.target.checked)} disabled={isDisbaled(node._id)} /></StyledTableCell>
                                                <StyledTableCell component="td" className={classes.tableCellPadding}  >{node.name}</StyledTableCell>
                                                <StyledTableCell component="td" className={classes.tableCellPadding}  >{node.clusterletType}</StyledTableCell>
                                                <StyledTableCell component="td" className={classes.tableCellPadding}  >{node?.attributes?.desc}</StyledTableCell>
                                            </StyledTableRow>
                                        ))
                                    }

                                    {/* {delegates.map(delegate => <StyledTableRow>
                            <StyledTableCell component="td" className={classes.tableCellPadding}  ><Checkbox checked={isChecked(delegate._id)} color='primary' onChange={e => onSelect(delegate, e.target.checked)} disabled={isDisbaled(delegate._id)} /></StyledTableCell>
                            <StyledTableCell component="td" className={classes.tableCellPadding}  >{delegate.name}</StyledTableCell>
                            <StyledTableCell component="td" className={classes.tableCellPadding}  >Delegate</StyledTableCell>
                            <StyledTableCell component="td" className={classes.tableCellPadding}  >{delegate?.attributes?.desc}</StyledTableCell>
                        </StyledTableRow>)}

                        {digitalTwins.map(dt => <StyledTableRow>
                            <StyledTableCell component="td" className={classes.tableCellPadding} ><Checkbox checked={isChecked(dt._id)} color='primary' onChange={e => onSelect(dt, e.target.checked)} disabled={isDisbaled(dt._id)} /></StyledTableCell>
                            <StyledTableCell component="td" className={classes.tableCellPadding} >{dt.name}</StyledTableCell>
                            <StyledTableCell component="td" className={classes.tableCellPadding} >Digital Twin</StyledTableCell>
                            <StyledTableCell component="td" className={classes.tableCellPadding} >{dt?.attributes?.desc}</StyledTableCell>
                        </StyledTableRow>)}

                        {analytics.map(analytic => <StyledTableRow>
                            <StyledTableCell component="td" className={classes.tableCellPadding} ><Checkbox checked={isChecked(analytic._id)} color='primary' onChange={e => onSelect(analytic, e.target.checked)} disabled={isDisbaled(analytic._id)} /></StyledTableCell>
                            <StyledTableCell component="td" className={classes.tableCellPadding} >{analytic.name}</StyledTableCell>
                            <StyledTableCell component="td" className={classes.tableCellPadding} >{analytic?.attributes?.type ? nodeKeysLabel[analytic?.attributes?.type] : process.env.REACT_APP_ANALYTICS}</StyledTableCell>
                            <StyledTableCell component="td" className={classes.tableCellPadding} >{analytic?.attributes?.desc}</StyledTableCell>
                        </StyledTableRow>)} */}

                                    {/* {templateClusterlets.map(template => <StyledTableRow>
                            <StyledTableCell component="td" className={classes.tableCellPadding} ><Checkbox checked={isChecked(template._id)} color='primary' onChange={e => onSelect({ ...template, category: 'templateClusterlet' }, e.target.checked)} disabled={isDisbaled(template._id)} /></StyledTableCell>
                            <StyledTableCell component="td" className={classes.tableCellPadding} >{template.name}</StyledTableCell>
                            <StyledTableCell component="td" className={classes.tableCellPadding} >Template</StyledTableCell>
                            <StyledTableCell component="td" className={classes.tableCellPadding} >{template?.attributes?.desc}</StyledTableCell>
                        </StyledTableRow>)} */}
                                </>
                            )}
                    </TableBody>
                </Table>
            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }} >
                <UpdateCancel onUpdate={onUpdate} onCancel={onCancel} updateDisable={isUpdating || loading} content={loading ? 'Loading..' : (isUpdating ? 'Updating...' : 'Update')} />
            </Grid>

            {evnetsAlert && <EventsAlert onCompletion={onConfirmUncheck} events={associatedEvents} onClose={() => setEventAlert(false)} />}

        </Grid>
    )
}